export const errorScreenIconSvg = require('./errorScreenIcon.svg').default;
//# sourceMappingURL=index.js.map